// toAbsoluteUrl — resolve a same-origin RELATIVE path to an absolute URL.
//
// Why this exists (nemesis finding, 2026-07-15): applying a PRESET wallpaper
// sends its path to POST /wheel/wheel-media/write/ (and stores it in
// wallpaper_settings.bg_wallpaper). Preset assets are served from the FE origin
// (S3/CloudFront) as a RELATIVE path like `/wallpaper-presets/webp/<slug>.webp`.
// The backend `urls` field is a Django URLField that requires an ABSOLUTE URL, so
// it rejected every preset with 400 "Enter a valid URL" — the preset never
// persisted. Uploaded media (absolute S3 URLs) already pass. Making the preset
// URL absolute (origin + path) makes it match the upload contract.
//
// Idempotent: an already-absolute URL (http(s)://, protocol-relative //, or a
// data: URI) is returned unchanged, so wrapping upload URLs is a safe no-op.
export function toAbsoluteUrl(path) {
  if (!path || typeof path !== "string") return path;
  // Already absolute: http://, https://, protocol-relative //host, or data:.
  if (/^(?:https?:)?\/\//i.test(path) || /^data:/i.test(path)) return path;
  const origin =
    (typeof window !== "undefined" &&
      window.location &&
      window.location.origin) ||
    "";
  if (!origin) return path; // no origin available (SSR/non-browser) — leave as-is
  return origin + (path.startsWith("/") ? path : "/" + path);
}

export default toAbsoluteUrl;
